import type { ScreenModule } from "../../../app/screen-module";
import { AuditPage } from "../pages";

export default {
	id: "tenant-admin.audit",
	path: "/admin/audit",
	area: "tenant-admin",
	navGroup: "管理",
	label: "監査ログ",
	roles: ["tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: AuditPage,
} satisfies ScreenModule;
